module.exports = __webpack_public_path__ + "media/images/vp/icon.ok.white-5e073b59c71cddab171a8040630f4b1a.png";